
import { defineComponent, onMounted } from "vue";
import ContentsList from "@components/contents/ContentsList.vue";
import { ciTrackingService } from "@services/ci-tracking.service";
import { MetaInfo } from "vue-meta";
import { alternateService } from "@services/alternate.service";

export default defineComponent({
  components: {
    ContentsList,
  },
  metaInfo(): MetaInfo {
    const title = this.$t("ui.views.contents.podcasts.meta_tags.title") as string;
    const description = this.$t("ui.views.contents.podcasts.meta_tags.description") as string;
    return {
      title: title,
      link: alternateService.fromRoute(this.$route),
      meta: [
        { vmid: "description", name: "description", content: description },
        { vmid: "og:title", property: "og:title", content: title },
        { vmid: "og:description", property: "og:description", content: description },
        { vmid: "twitter:title", name: "twitter:title", content: title },
        { vmid: "twitter:description", name: "twitter:description", content: description },
      ],
    };
  },
  setup() {
    onMounted(async () => {
      await ciTrackingService.trackView("PodcastOverview");
    });
  },
});
